export default __webpack_public_path__ + "static/media/colabgoogle.81f2e091.png";